import { Button } from '@gr-monorepo/common/ui';
import { PriorityProject, PriorityProjectStatus } from '../../model';
import {
  CardBodyWrapper,
  CardDates,
  CardDescription,
  CardTitle,
  CardTitleIcon,
  Plate,
  HeaderWrapper,
  TitleDatesWrapper,
} from './PriorityProjectCardStyled';
import { ReactComponent as Calendar } from '../../images/calendar.svg';
import React, { useState } from 'react';
import Spoiler from 'features/shared/Spoiler/Spoiler';
import { projectStatusToBtnState } from './StateButton';
import { StateButton } from './StateButton';
import { AdditionalDates } from './AdditionalDates';
import MarkdownPreview from 'features/shared/ui/MarkdownPreview/MarkdownPreview';
import { useClickStreamContext } from 'features/shared/ClickStream';

interface PriorityProjectCardProps {
  priorityProject: PriorityProject;
  onInformClick: () => void;
}

export const PriorityProjectCardHeader = ({ priorityProject }: { priorityProject: PriorityProject }) => {
  const btnState = projectStatusToBtnState(priorityProject.status);
  return (
    <HeaderWrapper>
      <TitleDatesWrapper>
        <CardTitle>
          {priorityProject.icon && <CardTitleIcon src={priorityProject.icon} alt={priorityProject.title} />}
          <span>{priorityProject.title}</span>
        </CardTitle>
        {priorityProject.dates && (
          <CardDates>
            <Calendar /> <span> {priorityProject.dates}</span>
          </CardDates>
        )}
      </TitleDatesWrapper>
      <StateButton state={btnState} />
    </HeaderWrapper>
  );
};

export const PriorityProjectCardBody = ({ priorityProject, onInformClick }: PriorityProjectCardProps) => {
  const isCurrent = priorityProject.status === PriorityProjectStatus.Current;
  return (
    <CardBodyWrapper>
      <CardDescription> <MarkdownPreview content={priorityProject.description} /></CardDescription>
      {priorityProject.additional_dates && <AdditionalDates dates={priorityProject.additional_dates} />}
      {priorityProject.inform_message && isCurrent && (
        <Button color="violet" style={{ width: 'fit-content' }} onClick={onInformClick}>
          проинформировать
        </Button>
      )}
    </CardBodyWrapper>
  );
};

const PriorityProjectCard = ({ priorityProject, onInformClick }: PriorityProjectCardProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const clickStream = useClickStreamContext()

  const onSpoilerChangeState = (isOpen: boolean)=>{
    setIsOpen(isOpen)
    clickStream.logPageEvent({
      eventType: 'priority-project-spoiler-click',
      eventInfo: `Клик по кнопке раскрыть проект, статус: ${isOpen ? "раскрыт" :"свернут"}`,
      cd1: priorityProject.title
    })
  }

  return (
    <Plate>
      <Spoiler
        summary={<PriorityProjectCardHeader priorityProject={priorityProject} />}
        summaryStyle={{ width: '100%', paddingRight: '20px' }}
        open={isOpen}
        onChangeState={onSpoilerChangeState}
        spoilerContent={<PriorityProjectCardBody priorityProject={priorityProject} onInformClick={onInformClick} />}
      />
    </Plate>
  );
};

export default PriorityProjectCard;
